import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowForwardIos } from '@mui/icons-material';
import { BIOLOGICAL_PRODUCT_ITEMS } from '../../Pages/Biological/modelCatalog';

const CATEGORIES = [
    {
        title: 'Biological Systems',
        subtitle: 'ODEs, reaction-diffusion, and agent-based biological systems',
        items: BIOLOGICAL_PRODUCT_ITEMS,
    },
    {
        title: 'Arcade',
        subtitle: 'Game arenas for agent training and benchmarking',
        items: [
            { title: 'Arcade Hub', description: 'Upload Python agents, compete across classic and modern games, and browse the built-in competition dashboard.', route: '/arcade' },
        ],
    },
    {
        title: 'Robotic',
        subtitle: 'Discrete event and multi-agent systems',
        items: [
            { title: 'Graph Based Systems', description: 'Markov chains plus supply-chain models — EOQ, transshipment, facility location, CVRP, and SDE inventory routing.', route: '/robotic/markov-chains' },
            { title: 'Mobility Systems', description: 'Grid-based multi-agent path finding and robot navigation.', route: '/robotic/mobility-systems' },
        ],
    },
    {
        title: 'Art',
        subtitle: 'Generative systems',
        items: [
            { title: 'Audio-Visualizer', description: 'Real-time spectral visualization from live audio streams.', route: '/art/audio-visualizer' },
        ],
    },
];

export default function Products() {
    const navigate = useNavigate();

    return (
        <Box id="product" sx={{ py: 10, bgcolor: '#0a0a0a', position: 'relative', borderTop: '1px solid #222' }}>
            <Box sx={{ textAlign: 'center', mb: 6, px: 2 }}>
                <Typography variant="h3" sx={{ color: 'white', fontWeight: 800, mb: 2 }}>
                    Evolving Systems
                </Typography>
                <Typography variant="h6" sx={{ color: '#a1a1aa' }}>
                    Explore living, robotic, artistic, and game-based AI environments
                </Typography>
            </Box>

            <Box sx={{ maxWidth: '1200px', mx: 'auto', px: 2 }}>
                {CATEGORIES.map((category) => (
                    <Box key={category.title} sx={{ mb: 6 }}>
                        <Typography variant="overline" sx={{ color: '#2cbb5d', fontWeight: 'bold', letterSpacing: 2 }}>
                            {category.title}
                        </Typography>
                        <Typography variant="h5" sx={{ color: '#fff', fontWeight: 700, mb: 1 }}>
                            {category.subtitle}
                        </Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 3, mt: 2 }}>
                            {category.items.map((item) => (
                                <Card
                                    key={item.route}
                                    onClick={() => navigate(item.route)}
                                    sx={{
                                        bgcolor: '#1e1e1e',
                                        borderRadius: '12px',
                                        border: '1px solid #333',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        '&:hover': { transform: 'translateY(-5px)', borderColor: '#555', boxShadow: '0 10px 30px rgba(0,0,0,0.5)' },
                                    }}
                                >
                                    <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', height: '100%' }}>
                                        <Typography variant="h5" color="white" fontWeight="bold" gutterBottom>
                                            {item.title}
                                        </Typography>
                                        <Typography variant="body2" color="#a1a1aa" sx={{ mb: 3, flexGrow: 1 }}>
                                            {item.description}
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', color: '#2cbb5d', fontWeight: 'bold', fontSize: '0.9rem' }}>
                                            Open System <ArrowForwardIos sx={{ fontSize: '12px', ml: 1 }} />
                                        </Box>
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
